import React from 'react';
import FormBuilder from "../components/FormikBuilder";
import moment from "moment";
import pendency, {Pendency as PendencyClass} from "../models/pendency";
import SnackMessage from '../components/FormikBuilder/SnackMessage';
import IconButtonBuilder from '../components/FormikBuilder/IconButtonBuilder';
import InputDateBuilder from '../components/FormikBuilder/InputDateBuilder';
import InputTimeBuilder from '../components/FormikBuilder/InputTimeBuilder';
import InputTextBuilder from '../components/FormikBuilder/InputTextBuilder';
import InputSelectBuilder from '../components/FormikBuilder/InputSelectBuilder';
import InputFileBuilder from '../components/FormikBuilder/InputFileBuilder';
import {Close, Description, Share} from '@material-ui/icons';
import {checkPendencyId, getAllocatedPendecyStatus} from '../provider/pendency.service';
import InputAutoCompleteBuilder from '../components/FormikBuilder/InputAutoCompleteBuilder';
import http from '../utils/api';
import {getColaborador} from '../utils/storage';
import localforage from '../utils/localforage';
import {v4 as uuid} from 'uuid';
import {receberAnexo} from '../provider/anexos.service';
import * as Yup from 'yup';


function PendencyCapacitacaoEffect({form}) {
    const pendenciaId = form.values.pendenciaId;
    React.useEffect(() => {
        if (!pendenciaId || form.values.tipoCapacitacao) return;
        const dataConsulta = moment(form.values.dataHoraInicio).isValid()
            ? moment(form.values.dataHoraInicio).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD');
        getAllocatedPendecyStatus(pendenciaId, dataConsulta)
            .then(({data: {data}}) => {
                const first = data?.[0];
                if (first?.status === 'OK' && first.tipoCapacitacao) {
                    form.setValues({
                        ...form.values,
                        tipoCapacitacao: first.tipoCapacitacao,
                        opcoesCapacitacao: first.opcoesCapacitacao || [],
                    });
                }
            })
            .catch(() => {});
    }, [pendenciaId]); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
}

function Pendency(thisProps) {
    const {data = {}, dateTime, hides, temp, ...other} = thisProps;
    if ((dateTime && !data?.horaInicio) || temp) {
        data.horaInicio = moment(data.dataHoraInicio).isValid() ? moment(data.dataHoraInicio).format('HH:mm') : null;
        data.horaFim = moment(data.dataHoraFim).isValid() ? moment(data.dataHoraFim).format('HH:mm') : null;
    }
    if (thisProps.isNew && !thisProps.withError) {
        data.dataHoraInicio = moment();
        data.horaInicio = null;
    }
    let atividadesAlocadas = [];
    return <FormBuilder
        key={'pendency' + Date.now()}
        data={data}
        initialState={pendency}
        validationSchema={Yup.object().shape({
            dataHoraInicio: Yup.string()
                .required('Required'),
            horaInicio: Yup.string()
                .required('Required'),
            horaFim: Yup.string()
                .required('Required'),
            codTipoCapacitacao: Yup.string()
                .nullable()
                .when('tipoCapacitacao', {
                    is: (val) => val === 'ONBOARDING' || val === 'ONGOING',
                    then: Yup.string().nullable().required('Required'),
                    otherwise: Yup.string().nullable(),
                }),
        })}
        autoFocus={thisProps.autoFocus}
        initialValue={new PendencyClass()}
        schema={(form) => ({
            actions: [
                {
                    label: 'Cancelar',
                    props: {
                        key: 'cancel',
                        type: 'button',
                    }
                },
                {
                    label: 'Limpar',
                    props: {
                        key: 'clear',
                        type: 'reset',
                        disabled: form.isSubmitting,
                    },
                    onClick: e => {
                        form.setValues(new PendencyClass())
                    }
                },
                {
                    label: form.isSubmitting ? 'enviando' : 'enviar',
                    props: {
                        key: 'submit',
                        type: 'submit',
                        variant: 'outlined',
                        disabled: form.isSubmitting
                    },
                    badge: 'Ctrl+Enter'
                }
            ],
            onSubmit: (e) => {
                e.preventDefault();
            },
        })} {...other}>
        {
            (form, props) => {

                const isPrendencyEmpty = () => !!form.getFieldMeta('pendenciaId').value?.length;

                const onChangeAutoComplete = (mantainField = 'descricao') => (ev, value = {}) => {
                    const dataHoraInicio = form.values.dataHoraInicio;
                    const horaInicio = form.values.horaInicio;
                    const horaFim = form.values.horaFim;
                    const codigoClassificacaoHoras = form.values.codigoClassificacaoHoras;
                    const codigoTipoAtividade = form.values.codigoTipoAtividade;
                    const descricao = form.values.descricao;
                    const caminhoArquivo = form.values.caminhoArquivo;
                    form.setValues({
                            dataHoraInicio,
                            horaInicio,
                            horaFim,
                            codigoClassificacaoHoras,
                            codigoTipoAtividade,
                            descricao,
                            caminhoArquivo,
                            [mantainField]: form.values[mantainField] ?? null,
                            ...value,
                        }
                        ?? {})
                };

                function getLinkApontamento() {
                    const data = {}
                    let url = new URL(`link-apontamento`, window.location.origin);
                    if (form.values.pendenciaId) {
                        data.pendenciaId = form.values.pendenciaId;
                    } else {
                        let filterAtivAloc = atividadesAlocadas.filter((opt) => opt?.['atividadeAlocada'] === form.values?.atividadeAlocada)
                        if (filterAtivAloc.length)
                            data.idAtividadeProjeto = filterAtivAloc?.[0].idAtividadeProjeto;
                    }
                    data.data = moment(form.values.dataHoraInicio).isValid() ? moment(form.values.dataHoraInicio).format('YYYY-MM-DD') : null;
                    data.horaFim = form.values.horaFim;
                    data.horaInicio = form.values.horaInicio;
                    data.descricao = form.values.descricao;
                    url = new URL('?' + Object.entries(data).filter(value => value && value !== '').map((value) => value.join('=')).join('&'), url)
                    window.prompt('(beta) Com esse link você pode compartilhar o apontamendo com outro colaborador', url)
                    // window.prompt('Com esse link você pode compartilhar o apontamendo com outro colaborador.\n (clique em "ok" para copiar para a àrea de transferência)', url)
                }

                return (<>
                    <PendencyCapacitacaoEffect form={form}/>
                    <SnackMessage form={form} formProps={props} fieldSchema={{
                        type: 'errorMessage',
                        field: 'status',
                        sizes: {
                            sm: 12,
                        },
                    }}/>

                    <IconButtonBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Colar Apontamento',
                        icon: Description,
                        tooltip: true,
                        sizes: {
                            sm: 12,
                            lg: 1,
                        },
                        onClick: (props) => {
                            const {
                                dataHoraFim,
                                dataHoraInicio,
                                horaInicio,
                                horaFim,
                                ...pendency
                            } = props.data.pendency;
                            form.setValues({...form.values, ...pendency})
                        },
                        type: 'iconButton',
                        hide: !dateTime || hides?.btnCopy,
                    }}/>

                    <InputDateBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Data *',
                        field: 'dataHoraInicio',
                        sizes: {
                            sm: 12,
                            lg: hides?.btnCopy ? 4 : 3,
                        },
                        format: 'DD/MM/YYYY',
                        type: 'date',
                        isRequired: true,
                        hide: !dateTime,
                        onChange: async (value) => {
                            form.setFieldValue('codigoProjeto', '');
                            form.setFieldValue('codigoSubsistema', '');
                            form.setFieldValue('atividadeAlocada', '');
                            await http.get('projetos-atividade', {
                                params: {
                                    qtdeItens: 9999,
                                    dataAlocacao: moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : null,
                                }
                            }).then(async ({data}) => {
                                await localforage.setItem('projetos-atividade', data.data);
                            });
                        },
                        onBlur: async (e, parsedValue) => {
                            await http.get('projetos-atividade', {
                            params: {
                                qtdeItens: 9999,
                                dataAlocacao: parsedValue?.isValid?.()
                                ? parsedValue.format('YYYY-MM-DD')
                                : null,
                            }
                            }).then(async ({ data }) => {
                            await localforage.setItem('projetos-atividade', data.data);
                            });
                        },
                    }}/>

                    <InputTimeBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Início (hh:mm) *',
                        field: 'horaInicio',
                        sizes: {
                            sm: 12,
                            lg: 4,
                        },
                        format: 'HH:mm',
                        type: 'time',
                        isRequired: true,
                        hide: !dateTime,
                    }}/>

                    <InputTimeBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Fim (hh:mm) *',
                        field: 'horaFim',
                        sizes: {
                            sm: 12,
                            lg: 4,
                        },
                        format: 'HH:mm',
                        type: 'time',
                        isRequired: true,
                        hide: !dateTime,
                        autoFocus: true,
                    }}/>

                    <InputTextBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Pendência',
                        field: 'pendenciaId',
                        sizes: {
                            sm: 12,
                            lg: 3,
                        },
                        type: 'text',
                        onBlur: checkPendencyId,
                        isRequired: true,
                        disableClear: true,
                        adornment: {
                            icon: Close,
                            condition: isPrendencyEmpty(),
                            className: 'clear',
                            onClick: (e) => {
                                form.setValues({
                                    ...form.values,
                                    pendenciaId: '',
                                    codigoProjeto: '',
                                    codigoSubsistema: '',
                                    atividadeAlocada: '',
                                    codTipoCapacitacao: null,
                                    tipoCapacitacao: null,
                                    opcoesCapacitacao: [],
                                });
                            }
                        }
                    }}/>

                    <InputAutoCompleteBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Projeto',
                        field: 'codigoProjeto',
                        sizes: {
                            sm: 12,
                            lg: 4,
                        },
                        clear: () => {
                            form.setValues({
                                ...form.values,
                                codigoProjeto: '',
                                codigoSubsistema: '',
                                atividadeAlocada: '',
                            });
                        },
                        listen: 'dataHoraInicio',
                        disabled: isPrendencyEmpty(),
                        getOptions: (async (setOptions) => {
                            const dataAlocacaoStr = moment(form.values?.['dataHoraInicio']).isValid()
                                ? moment(form.values?.['dataHoraInicio']).format('YYYY-MM-DD')
                                : null;
                            const response = await http.get('projetos-atividade', {
                                params: { qtdeItens: 9999, dataAlocacao: dataAlocacaoStr }
                            });
                            const data = response?.data?.data;
                            setOptions(data);
                            await localforage.setItem('projetos-atividade', data);
                        }),
                        onChange: onChangeAutoComplete(),
                        getOptionLabel: option => (option?.['codigoProjeto'] && `${option['codigoProjeto']} ${option['codigoArea'] ? `(${option['codigoArea']})` : ''}`) || '',
                        type: 'autocomplete',
                    }}/>

                    <InputAutoCompleteBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Subsistema',
                        field: 'codigoSubsistema',
                        sizes: {
                            sm: 12,
                            lg: 5,
                        },
                        listen: 'codigoProjeto',
                        getOptionLabel: option => (option?.['codigoSubsistema'] && `${option['codigoSubsistema']} ${option['codigoArea'] ? `(${option['codigoArea']})` : ''}`) || '',
                        getOptions: (async (setOptions) => {
                            let resultsArray = [];
                            if (form.values?.['codigoProjeto']) {
                                const response = await http.get(`subsistemas-alocados`, {
                                    params: {
                                        codigoProjeto: form.values?.['codigoProjeto'],
                                        qtdeItens: 9999,
                                        dataAlocacao: moment(form.values?.['dataHoraInicio']).isValid() ? moment(form.values?.['dataHoraInicio']).format('YYYY-MM-DD') : null,
                                    }
                                });
                                resultsArray = (response?.data?.data ?? []).map(option => {
                                    option.codigoSubsistemaDescricao = option.descricao;
                                    delete option.descricao;
                                    return option
                                });
                                setOptions(resultsArray);
                            }

                        }),
                        onChange: onChangeAutoComplete('codigoProjeto'),
                        disabled: isPrendencyEmpty() || !form.values?.['codigoProjeto'] || form.values?.['codigoProjeto'] === '',
                        type: 'autocomplete',
                        clear: () => {
                            form.setValues({
                                ...form.values,
                                codigoSubsistema: '',
                                atividadeAlocada: '',
                            });
                        },
                    }}/>

                    <InputAutoCompleteBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Atividade Alocada',
                        field: 'atividadeAlocada',
                        sizes: {
                            sm: 12,
                            lg: 12,
                        },
                        listen: 'codigoSubsistema',
                        getOptionLabel: option => (option?.['atividadeAlocada']) ?? '',
                        getOptions: (async (setOptions) => {
                            if (form.values?.['codigoSubsistema']) {
                                const response = await http.get(`atividades-alocadas`, {
                                    params: {
                                        codigoSubsistema: form.values?.['codigoSubsistema'],
                                        codigoArea: form.values?.['codigoArea'] ?? getColaborador().area,
                                        codigoProjeto: form.values?.['codigoProjeto'],
                                        qtdeItens: 9999,
                                        dataAlocacao: moment(form.values?.['dataHoraInicio']).isValid() ? moment(form.values?.['dataHoraInicio']).format('YYYY-MM-DD') : null,
                                    }
                                });
                                let resultsArray = response?.data?.data ?? [];
                                resultsArray = resultsArray.map(option => {
                                    option.atividadeAlocada = option.descricao;
                                    delete option.descricao;
                                    return option
                                });
                                atividadesAlocadas = resultsArray;
                                setOptions(resultsArray);
                            }
                        }),
                        onChange: onChangeAutoComplete('codigoSubsistema'),
                        type: 'autocomplete',
                        disabled: isPrendencyEmpty() || !form.values?.['codigoSubsistema'] || form.values?.['codigoSubsistema'] === '',
                        clear: () => {
                            form.setValues({
                                ...form.values,
                                atividadeAlocada: '',
                            });
                        },
                    }}/>

                    <InputTextBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Descricao',
                        field: 'descricao',
                        sizes: {
                            sm: 12,
                            lg: 12,
                        },
                        type: 'text'
                    }}/>

                    {(form.values.tipoCapacitacao === 'ONBOARDING' || form.values.tipoCapacitacao === 'ONGOING') && (
                        <InputSelectBuilder
                            key={(form.values.opcoesCapacitacao || []).map(o => `${o.codTipoCapacitacao}:${o.descricao ?? ''}`).join(',')}
                            form={form} formProps={props} fieldSchema={{
                            label: 'Tipo de Capacitação',
                            field: 'codTipoCapacitacao',
                            sizes: {
                                sm: 12,
                                lg: 6,
                            },
                            type: 'select',
                            isRequired: true,
                            options: Promise.resolve(
                                (form.values.opcoesCapacitacao || []).map(o => ({
                                    codigo: o.codTipoCapacitacao,
                                    descricao: o.descricao,
                                }))
                            ),
                        }}/>
                    )}

                    <InputSelectBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Classificação',
                        field: 'codigoClassificacaoHoras',
                        sizes: {
                            sm: 12,
                            lg: 6,
                        },
                        type: 'select',
                        isRequired: true,
                        default: 'NO',
                        options: localforage.getItem('classificacoes-horas')
                    }}/>

                    <InputSelectBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Tipo',
                        field: 'codigoTipoAtividade',
                        sizes: {
                            sm: 12,
                            lg: 6,
                        },
                        type: 'select',
                        isRequired: true,
                        default: 'PR',
                        options: localforage.getItem('tipos-atividade'),
                    }}/>

                    <InputFileBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Anexo',
                        field: 'caminhoArquivo',
                        sizes: {
                            sm: 12,
                            lg: 12,
                        },
                        type: 'file',
                        onChange: (file) => {
                            const random = uuid().split('-')[0];
                            const blob = file.slice(0, file.size, file.type);
                            const fileName = `MC-${random}-${file.name}`;
                            const newFile = new File([blob], fileName, {type: file.type});

                            const formData = new FormData();
                            formData.append("anexo", newFile);
                            form.setValues({
                                ...form.values,
                                anexo: formData
                            })
                        },
                        closePreview: ([, setImg]) => {
                            setImg(null)
                        },
                        disabled: form.values?.['codigoTipoAtividade'] !== 'FJ',
                        onMount: (setImg, setFile) => {
                            const filePath = form.values?.['caminhoArquivo'];
                            let fileName = filePath.split('/');
                            fileName = fileName[fileName.length - 1]
                            receberAnexo(fileName).then(base64 => {
                                setImg(base64);
                                setFile({
                                    name: fileName.split('-').slice(2).join('-')
                                })
                            }).catch(console.log)
                        }
                    }}/>

                    <IconButtonBuilder form={form} formProps={props} fieldSchema={{
                        label: 'Gerar Link',
                        icon: Share,
                        tooltip: true,
                        sizes: {
                            sm: 12,
                            lg: 1,
                        },
                        badge: 'beta',
                        onClick: getLinkApontamento,
                        type: 'iconButton',
                        hide: !dateTime || hides?.btnShare,
                    }}/>

                </>)
            }
        }
    </FormBuilder>;
}

export default Pendency;
